/* Brics Craft - carrinho drawer (modelo 1E Minimal): contador de reserva e upsell */
(function () {
  'use strict';

  if (window.__bcCartDrawer) return;
  window.__bcCartDrawer = true;

  var TIMER_KEY = 'bcCartReserveEndsAt';

  function storageGet(key) {
    try {
      return window.sessionStorage.getItem(key);
    } catch (_) {
      return null;
    }
  }

  function storageSet(key, value) {
    try {
      window.sessionStorage.setItem(key, value);
    } catch (_) {}
  }

  // Começa na primeira abertura do carrinho e não reinicia na mesma sessão.
  function timerEndsAt(minutes) {
    var saved = parseInt(storageGet(TIMER_KEY), 10);
    if (saved) return saved;
    var endsAt = Date.now() + minutes * 60 * 1000;
    storageSet(TIMER_KEY, String(endsAt));
    return endsAt;
  }

  function hideExpiredTimers() {
    if (document.getElementById('bc-cart-timer-expired')) return;
    var style = document.createElement('style');
    style.id = 'bc-cart-timer-expired';
    style.textContent = 'cart-drawer.bc-drawer .bc-drawer__timer{display:none!important}';
    document.head.appendChild(style);
  }

  var savedEndsAt = parseInt(storageGet(TIMER_KEY), 10);
  if (savedEndsAt && savedEndsAt <= Date.now()) hideExpiredTimers();

  function pad(value) {
    return value < 10 ? '0' + value : String(value);
  }

  function tickTimers() {
    // Só atualiza com o drawer aberto: a página de produto tem observers que
    // varrem o DOM inteiro a cada mudança.
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || !drawer.classList.contains('active')) return;
    if (document.getElementById('bc-cart-timer-expired')) return;
    var timers = drawer.querySelectorAll('[data-bc-timer]');
    if (!timers.length) return;
    var minutes = parseInt(timers[0].getAttribute('data-minutes'), 10) || 15;
    var remaining = timerEndsAt(minutes) - Date.now();
    if (remaining <= 0) {
      hideExpiredTimers();
      return;
    }
    var totalSeconds = Math.ceil(remaining / 1000);
    var text = pad(Math.floor(totalSeconds / 60)) + ':' + pad(totalSeconds % 60);
    for (var i = 0; i < timers.length; i++) {
      var node = timers[i].firstChild;
      // Troca só o texto (characterData), sem recriar nós (childList).
      if (node && node.nodeType === 3) {
        if (node.nodeValue !== text) node.nodeValue = text;
      } else {
        timers[i].textContent = text;
      }
    }
  }

  tickTimers();
  window.setInterval(tickTimers, 1000);

  var drawerElement = document.querySelector('cart-drawer');
  if (drawerElement && window.MutationObserver) {
    new MutationObserver(tickTimers).observe(drawerElement, { attributes: true, attributeFilter: ['class'] });
  }

  function sectionsToRender(drawer) {
    return drawer && typeof drawer.getSectionsToRender === 'function'
      ? drawer.getSectionsToRender().map(function (section) {
          return section.id;
        })
      : ['cart-drawer', 'cart-icon-bubble'];
  }

  function addUpsell(button) {
    var variantId = parseInt(button.getAttribute('data-bc-upsell-add'), 10);
    var drawer = document.querySelector('cart-drawer');
    if (!variantId || !drawer) return;

    button.setAttribute('aria-busy', 'true');
    var label = button.textContent;
    button.textContent = 'Adicionando…';

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1 }],
        sections: sectionsToRender(drawer),
        sections_url: window.location.pathname,
      }),
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok || data.status) throw new Error(data.description || data.message || 'Erro ao adicionar');
          return data;
        });
      })
      .then(function (data) {
        drawer.classList.remove('is-empty');
        drawer.renderContents({ id: data.items && data.items[0] && data.items[0].product_id, sections: data.sections });
        if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'bc-cart-upsell', productVariantId: variantId });
        }
      })
      .catch(function (error) {
        button.removeAttribute('aria-busy');
        button.textContent = label;
        var errors = document.getElementById('CartDrawer-CartErrors');
        if (errors) errors.textContent = error.message || (window.cartStrings && window.cartStrings.error) || '';
      });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[data-bc-upsell-add]');
    if (!button || button.getAttribute('aria-busy') === 'true') return;
    event.preventDefault();
    addUpsell(button);
  });
})();
